import Component from '../core/Component'
import Flickity from 'flickity'


export const STATUS = {
    READY: 'is-ready'
}

export default class TestimonialSlider extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            wrap: null,
            slides: [],
            index: null,
        }
    }

    prepare() {

        if (this.ref.slides.length > 1) {
            this.element.classList.add(STATUS.READY)
            this.flickity = new Flickity(this.ref.wrap, {
                cellSelector: '.testimonial-slider__slide',
                prevNextButtons: true,
                pageDots: false,
                cellAlign: "left",
                contain: true,
                groupCells: true,
                resize: true,
                wrapAround: false,
                pageDots: true,
                arrowShape: 'M1.9 47.2l29.8-29.8c1.9-1.7 4.8-1.6 6.6.3 1.6 1.8 1.6 4.5 0 6.3L16.4 45.9h79.5c2.6 0 4.7 2.1 4.7 4.6 0 2.6-2.1 4.7-4.6 4.7H16.4L38.2 77c1.7 1.9 1.6 4.8-.3 6.6-1.8 1.6-4.5 1.6-6.3 0L1.9 53.8C0 52 0 49 1.9 47.2z'
                //adaptiveHeight: true
            })
        }
    }

}